import CaseStudyStoryItem from "./CaseStudyStoryItem";

export default CaseStudyStoryItem;